import React, { Component } from 'react'

import Modal from './Modal'
import { Filters, FilterEditor } from "../filters";

export default class FilterEditorModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: props.show,
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }

  render() {
    return (
      <>
        <style
          dangerouslySetInnerHTML={{
            __html: `
              .modal-backdrop.show {
                  opacity:0;
              }
            `,
          }}
        />
        <Modal
          className="modal-filter-editor p-btm"
          show={this.state.show}
          onHide={() => {
            this.props.onHide()
          }}
        >
          <FilterEditor
            compact={true}
            filter={this.props.filter}
            onUpdated={this.props.onUpdated}
          />
        </Modal>
      </>
    )
  }
}
